<script>
import { mapGetters, mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'
import CustomAlert from '@/components/common/CustomAlert.vue'
export default {
  name: 'DeleteAccountConfirmation',
  components: { CustomAlert },
  mixins: [validationMixin],
  validations: {
    pwd: {
      required,
      minLength: minLength(6),
      hasCapital(pwd) {
        return /[A-Z]/.test(pwd)
      },
      hasNum(pwd) {
        return /[0-9]/.test(pwd)
      },
      hasSpecialChar(pwd) {
        return /\W|_/.test(pwd)
      }
    }
  },
  data: () => ({
    pwd: '',
    showPwd: false,
    submitError: false,
    loading: false
  }),
  computed: {
    ...mapGetters(['username']),
    pwdErrors() {
      const errors = []
      if (!this.$v.pwd.$dirty) return errors
      !this.$v.pwd.required &&
        errors.push(this.$t('validation.password.required'))
      !this.$v.pwd.minLength &&
        errors.push(this.$t('validation.password.min.length'))
      !this.$v.pwd.hasCapital &&
        errors.push(
          this.$t('validation.password.capital.letter.required')
        )
      !this.$v.pwd.hasNum &&
        errors.push(this.$t('validation.password.number.required'))
      !this.$v.pwd.hasSpecialChar &&
        errors.push(
          this.$t('validation.password.special.char.required')
        )
      return errors
    }
  },
  methods: {
    ...mapActions(['logoutUser']),
    deleteAccount() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.$userService
          .deleteUserAccount({
            userEmail: this.username,
            password: this.pwd
          })
          .then(() => {
            this.logoutUser().then(() => {
              this.$emit('confirmed')
            })
          })
          .catch(() => {
            this.submitError = true
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    close() {
      this.$v.$reset()
      this.submitError = false
      this.$emit('close')
    }
  }
}
</script>
<template>
  <v-card>
    <DialogBaseColoredTitle color="primary">
      {{ $t('component.profile.accountManagement.deleteAccount.deleteAccountConfirmation.delete.dialog.header') }}
    </DialogBaseColoredTitle>
    <DialogBaseCloseIcon color="white" @click="close" />
    <v-divider></v-divider>
    <DialogBaseText class="text-center primary--text">
      <CustomAlert :show-alert="submitError" alert-type="error">
        <span class="body-2 cms_validatorMsg">{{
            $t('validation.current.password.mismatch')
          }}</span> </CustomAlert><span>
      {{ $t('component.profile.accountManagement.deleteAccount.deleteAccountConfirmation.delete.dialog.text') }}</span>
      <v-text-field
        id="passwordForDeletion"
        v-model="pwd"
        class="cms_pw pt-8"
        :label="$t('component.profile.accountManagement.deleteAccount.deleteAccountConfirmation.password.label')"
        :error-messages="pwdErrors"
        :type="showPwd ? 'text' : 'password'"
        :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
        outlined
        dense
        required
        @input="$v.pwd.$touch()"
        @keyup.enter.native="deleteAccount()"
        @click:append="showPwd = !showPwd"
      ></v-text-field>
    </DialogBaseText>
    <v-divider></v-divider>
    <DialogBaseActions>
      <v-row class="ma-0">
        <v-col>
          <v-btn
            id="cancelDeletion"
            color="secondary"
            class="white--text px-8"
            @click="close"
          ><span>{{ $t('button.cancel') }}</span></v-btn>
        </v-col>
        <v-col>
          <v-btn
            id="confirmDeletion"
            :loading="loading"
            color="error"
            class="white--text px-8"
            @click.stop="deleteAccount"
          ><span>{{ $t('button.delete') }}</span></v-btn>
        </v-col>
      </v-row>
    </DialogBaseActions>
  </v-card>
</template>
<style lang="scss" scoped>
.close-icon {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
